module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report-detail"
  }, [(!_vm.$store.state.report.isShowPersonalDetail) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.detail.loading),
      expression: "detail.loading"
    }]
  }, [_c('el-row', {
    staticClass: "rd-tool-bar"
  }, [_c('el-button', {
    staticClass: "rd-btn",
    attrs: {
      "loading": _vm.csvLoading
    },
    on: {
      "click": _vm.getCSVData
    }
  }, [_vm._v("\n\t\t\t\t下載報表\n\t\t\t")]), _vm._v(" "), _c('downloadCsv', {
    ref: "downloadCsv",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "data": _vm.csvData,
      "name": "data.csv",
      "labels": _vm.labels
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticClass: "page-bar"
  }, [_c('div'), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "prev-text": "prev",
      "next-text": "next",
      "current-page": _vm.$store.state.report.detailListStatus.pagination.current_page,
      "page-size": _vm.$store.state.report.detailListStatus.pagination.page_size,
      "total": _vm.detailDataSoruce.length
    },
    on: {
      "current-change": _vm.detail_current_change
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.detail.loading),
      expression: "detail.loading"
    }],
    staticClass: "detail-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.detailData,
      "empty-text": "暫無數據"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actual_dep_name",
      "label": "部門"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "工號"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "view_count",
      "label": "閱覽次數"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "詳細記錄"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.view_count > 0) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.listDetail(scope.row.id, scope.row.name)
            }
          }
        }, [_vm._v("查看")]) : _vm._e()]
      }
    }], null, false, 2201531780)
  })], 1)], 1) : _c('div', [_c('el-row', {
    staticClass: "rd-tool-bar"
  }, [_c('el-button', {
    staticClass: "rd-btn",
    attrs: {
      "loading": _vm.csvLoadingDetail
    },
    on: {
      "click": _vm.getCSVDataDetail
    }
  }, [_vm._v("\n\t\t\t\t下載報表\n\t\t\t")]), _vm._v(" "), _c('downloadCsv', {
    ref: "downloadCsvDetail",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "data": _vm.csvDataDetail,
      "name": "data.csv",
      "labels": _vm.labelsDetail
    }
  })], 1), _vm._v(" "), _c('el-row', {
    staticClass: "page-bar"
  }, [_c('div'), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "prev-text": "prev",
      "next-text": "next",
      "current-page": _vm.$store.state.report.personalListStatus.pagination.current_page,
      "page-size": _vm.$store.state.report.personalListStatus.pagination.page_size,
      "total": _vm.personalDataSoruce.length
    },
    on: {
      "current-change": _vm.personal_current_change
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.personal.loading),
      expression: "personal.loading"
    }],
    staticClass: "detail-table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.personalData,
      "empty-text": "暫無數據"
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "150px",
      "prop": "date",
      "label": "日期"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "主題名稱"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.goResource(scope.row.id)
            }
          }
        }, [_vm._v(" " + _vm._s(scope.row.title) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "file",
      "label": "檔案名稱"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150px",
      "prop": "duration",
      "label": "觀看秒數"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b55ec0f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/ReportDetail.vue
// module id = 953
// module chunks = 170